import React from 'react';
import { motion } from 'framer-motion';
import './Legal.css';

const CommunityGuidelines = () => {
  return (
    <motion.div 
      className="legal-content"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="legal-header">
        <a href="/" className="back-link">← Back to Home</a>
        <h1>Community Guidelines</h1>
        <p className="last-updated">Last updated: May 4, 2026</p>
      </div>

      <motion.section 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.1 }}
      >
        <h2>1. Keep Grind On Safe</h2>
        <p>Grind On is for fitness progress, discipline, encouragement, and respectful community interaction. We do not tolerate objectionable content or abusive users.</p>
      </motion.section>

      <motion.section 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.2 }}
      >
        <h2>2. Prohibited Content</h2>
        <ul>
          <li>Harassment, bullying, intimidation, threats, or personal attacks.</li>
          <li>Hate speech or discriminatory content targeting protected groups.</li>
          <li>Sexually explicit, pornographic, exploitative, or nude content.</li>
          <li>Graphic violence, self-harm encouragement, or violent threats.</li>
          <li>Spam, scams, impersonation, misleading claims, or illegal activity.</li>
          <li>Content that violates another person's privacy or intellectual property.</li>
        </ul>
      </motion.section>

      <motion.section 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.3 }}
      >
        <h2>3. Filtering, Reporting, and Blocking</h2>
        <p>We use content filtering to prevent objectionable material from being posted. Users can report posts, comments, and replies from inside the app. Users can also block abusive accounts, which removes that person's content from their feed immediately and notifies Grind On.</p>
      </motion.section>

      <motion.section 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.4 }}
      >
        <h2>4. Moderation Response</h2>
        <p>Grind On reviews objectionable content reports within 24 hours. When content violates these guidelines, we may remove it and eject the user who provided the offending content.</p>
      </motion.section>

      <motion.section 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.5 }}
      >
        <h2>5. Contact</h2>
        <p>To reach us about safety, moderation, or support, email <strong><a href="mailto:support@grindon.fitness">support@grindon.fitness</a></strong>.</p>
      </motion.section>
    </motion.div>
  );
};

export default CommunityGuidelines;
